import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import DashboardHeader from "../applicantForms/dashboardHeader";
import DashBoardContainer from "../../components/containers/dashboardContainer";
import ReviewCard from "../../components/reviewCard";
import profile_pic from "../../assets/images/icons/profile-pic.png";

import {
  fetchFirmApplication,
  updateFirmApplication,
  fetchFile,
} from "../../actions";
import ier_logo from "../../assets/images/icons/ier-logo2.png";

const FirmApplicationStatus = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const apiResponse = useSelector((state) => {
    const {
      firmApplication,
      fetchFile,
      firmApplicationSubmitted,
      updatedFirmApplication,
    } = state;
    const { application } = firmApplication;
    const { file } = fetchFile;
    const { response } = firmApplicationSubmitted;
    const { status } = updatedFirmApplication;

    return {
      application,
      file,
      response,
      status,
    };
  });

  const [applicationDetails, setApplicationDetails] = useState({});

  const [hasDownloaded, setHasDownloaded] = useState(false);
  const [download, setDownload] = useState(false);

  var currentUser = JSON.parse(localStorage.getItem("currentUser"));
  var applicationId =
    apiResponse.application?.id || apiResponse.application?.applicationId;
  const [requestId, setRequestId] = useState("");

  useEffect(() => {
    if (
      props.location &&
      props.location.state &&
      props.location.state.application
    ) {
      dispatch(fetchFirmApplication(props.location.state.application.id));
    }
  }, []);

  useEffect(() => {
    if (apiResponse.response?.status === "success") {
      dispatch(fetchFirmApplication(currentUser.sub));
    }
    if (
      apiResponse.status === requestId &&
      apiResponse.response?.status === "success"
    ) {
      history.push({
        pathname: "/applicant/payment-details",
        state: applicationDetails,
      });
    }
  }, [apiResponse.response]);

  useEffect(() => {
    if (apiResponse.file?.fileText != null && !hasDownloaded && download) {
      var a = document.createElement("a");
      a.href =
        "data:image/" +
        apiResponse.file?.type +
        ";base64," +
        apiResponse.file?.fileText;
      a.download =
        apiResponse.file?.name || "File" + "." + apiResponse.file?.type || "";
      a.click();
      setHasDownloaded(true);
    }
  }, [apiResponse.file]);

  useEffect(() => {
    if (apiResponse.application?.id) {
      setApplicationDetails({
        ...apiResponse.application,
      });
    }
  }, [apiResponse.application]);

  const handleSaveForLater = () => {
    const reqId = uuidv4();
    setRequestId(reqId);
    const sentData = {
      ...applicationDetails,
      step: 7,
      status: "submitted",
    };
    if (applicationId) {
      dispatch(
        updateFirmApplication({
          data: {
            ...sentData,
          },
          id: applicationId,
          reqId: reqId,
        }),
      );
    }
  };

  const handleSubmit = () => {
    // history.push('/applicant/payment-details')
    handleSaveForLater();
  };

  const handleFileDownload = (value) => {
    let url;
    if (value) {
      url = encodeURIComponent(
        value.substring(value.indexOf("/tmp"), value.length),
      );
      dispatch(fetchFile(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };

  const handleCancel = () => {
    history.push("/applicant/company/attachments");
  };
  return (
    <div>
      <DashboardHeader activeStep={8} />
      <DashBoardContainer
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        title="Next"
        borderLess={true}
        handleSaveForLater={handleSaveForLater}
        middleTitle="Save for Later"
      >
        <div className="d-flex mb-2">
          <span
            className="dashboard-green-text-header"
            style={{ margin: "auto" }}
          >
            Review application details
          </span>
        </div>
        <div className="dashboard-review-container">
          <div className="dashboard-review-title-container">
            <div
              style={{
                width: "50%",
              }}
            >
              <img src={ier_logo} />
            </div>
            <div
              style={{
                width: "20%",
                display: "flex",
              }}
            >
              <span className="review-header-apllication-text">
                APPLICATION DETAILS <br />
                for <br />
                <span
                  style={{
                    fontSize: "30px",
                  }}
                >
                  Graduate Engineer
                </span>
              </span>
            </div>
          </div>
          <div>
            <ReviewCard title="Company details">
              <div
                className="review-details-content-conatiner"
                style={{ justifyContent: "space-between" }}
              >
                <div className="review-details-profile-container">
                  <div className="review-details-profile-icon">
                    <img src={profile_pic} />
                  </div>
                  <div>
                    <div>
                      <span>Company names</span>
                      <p>{applicationDetails.companyNames}</p>
                    </div>
                    <div>
                      <span>Company activities</span>
                      <p>{applicationDetails.companyActivities}</p>
                    </div>
                  </div>
                </div>

                <div className="review-details-gender-details">
                  <div>
                    <span>Date of business registration</span>
                    <p>{applicationDetails.registrationDate}</p>
                  </div>
                  <div>
                    <span>Business Certificate number</span>
                    <p>{applicationDetails.businessCertificateNumber}</p>
                  </div>
                </div>
              </div>
            </ReviewCard>

            <ReviewCard title="Contact details">
              <div className="review-details-content-conatiner">
                <div className="review-details-contact-container-first">
                  <div className="d-flex">
                    <div className="contancts-container">
                      <div>
                        <span>Phone number</span>
                        <p>{applicationDetails.contactTelephoneNumber}</p>
                      </div>
                    </div>
                    <div className="">
                      <div>
                        <span>Email address</span>
                        <p>{applicationDetails.contactEmail}</p>
                      </div>
                    </div>
                  </div>
                  <div className="seperator-contact"></div>
                  <div className="d-flex">
                    <div className="contancts-container">
                      <div>
                        <span>Secondary Phone number</span>
                        <p>
                          {applicationDetails.secondaryContactTelephoneNumber}
                        </p>
                      </div>
                    </div>
                    <div className="">
                      <div>
                        <span>Main Email address</span>
                        <p>{applicationDetails.secondaryContactEmail}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="review-details-contact-container-second">
                  <div className="">
                    <div>
                      <span>Residence Address</span>
                      <p>
                        {applicationDetails.provinceId?.name},{" "}
                        {applicationDetails.districtId?.name},{" "}
                        {applicationDetails.sectorId?.name},{" "}
                        {applicationDetails.cellId?.name},{" "}
                        {applicationDetails.villageId?.name},{" "}
                        {applicationDetails.streetOrHouseNumber}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ReviewCard>

            <ReviewCard title="Company Directors/ Shareholders">
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  {applicationDetails.stakeholders?.length > 0 &&
                    applicationDetails.stakeholders?.map((value) => {
                      return (
                        <>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <div>
                                <span>Full names</span>
                                <p>{value.fullName}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Qualification</span>
                                <p>{value.qualification}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Phone</span>
                                <p>{value.telephoneNumber}</p>
                              </div>
                            </div>
                            <div>
                              <span>National ID number</span>
                              <p>{value.nationalIdNumber}</p>
                            </div>
                            <div>
                              <span>IER number</span>
                              <p>{value.ierMemberNumber}</p>
                            </div>
                          </div>
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </>
                      );
                    })}
                </div>
              </div>
            </ReviewCard>
            <ReviewCard title="Projects accomplished details">
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  {applicationDetails.projects?.length > 0 &&
                    applicationDetails.projects.map((value) => {
                      return (
                        <>
                          <div
                            className="d-flex"
                            style={{ justifyContent: "space-between" }}
                          >
                            <div>
                              <div>
                                <span>Name of the project</span>
                                <p>{value.name}</p>
                              </div>
                            </div>
                            <div className="">
                              <div>
                                <span>Client</span>
                                <p>{value.client}</p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </>
                      );
                    })}
                </div>
              </div>
            </ReviewCard>

            <ReviewCard title="Attachments">
              <div className="review-details-content-conatiner">
                <div
                  className="review-details-contact-container-first"
                  style={{ width: "100%" }}
                >
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <span>Attach Technical report</span>
                      {/* <img src={`data:image/${applicationDetails.technicalReportFile?.type};base64,${applicationDetails.technicalReportFile?.fileText}`} style={{width: 150, height: 150}}/> */}
                      <p>{applicationDetails.technicalReportFile?.name}</p>
                      <span
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.technicalReportFile?.fileText,
                          )
                        }
                        style={{ paddingBottom: "0px" }}
                      >
                        download
                      </span>
                    </div>

                    <div>
                      <span>Attach certified Business certificate</span>
                      {/* <img src={`data:image/${applicationDetails.businessCertificateDocumentFile?.type};base64,${applicationDetails.businessCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                      <p>
                        {
                          applicationDetails.businessCertificateDocumentFile
                            ?.name
                        }
                      </p>
                      <span
                        style={{ marginBottom: "0px" }}
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.businessCertificateDocumentFile
                              ?.fileText,
                          )
                        }
                      >
                        download
                      </span>
                    </div>

                    <div>
                      <span>Attach RDB Registration Certificate</span>
                      {/* <img src={`data:image/${applicationDetails.rdbRegistrationDocumentFile?.type};base64,${applicationDetails.rdbRegistrationDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                      <p>
                        {applicationDetails.rdbRegistrationDocumentFile?.name}
                      </p>
                      <span
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.rdbRegistrationDocumentFile
                              ?.fileText,
                          )
                        }
                        style={{ marginBottom: "0px" }}
                      >
                        download
                      </span>
                    </div>
                    <div>
                      <span>Attach RRA Tax Clearance Certificate</span>
                      {/* <img src={`data:image/${applicationDetails.taxClearanceDocumentFile?.type};base64,${applicationDetails.taxClearanceDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                      <p style={{ marginBottom: "0px" }}>
                        {applicationDetails.taxClearanceDocumentFile?.name}
                      </p>
                      <span
                        style={{ marginBottom: "0px" }}
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.taxClearanceDocumentFile
                              ?.fileText,
                          )
                        }
                      >
                        download
                      </span>
                    </div>
                  </div>
                  <div
                    className="seperator-contact"
                    style={{ width: "100%" }}
                  ></div>
                  <div
                    className="d-flex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <span>
                        Attach Managing/Technical Director’s Practicing License
                      </span>
                      {/* <img src={`data:image/${applicationDetails.practicingLicenseDocumentFile?.type};base64,${applicationDetails.practicingLicenseDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                      <p>
                        {applicationDetails.practicingLicenseDocumentFile?.name}
                      </p>
                      <span
                        style={{ marginBottom: "0px" }}
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.practicingLicenseDocumentFile
                              ?.fileText,
                          )
                        }
                      >
                        download
                      </span>
                    </div>

                    <div>
                      <span>Attach Company Profile</span>
                      {/* <img src={`data:image/${applicationDetails.companyProfileDocumentFile?.type};base64,${applicationDetails.companyProfileDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                      <p>
                        {applicationDetails.companyProfileDocumentFile?.name}
                      </p>
                      <span
                        style={{ marginBottom: "0px" }}
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.companyProfileDocumentFile
                              ?.fileText,
                          )
                        }
                      >
                        download
                      </span>
                    </div>

                    <div>
                      <span>Attach RSSB Certificate</span>
                      {/* <img src={`data:image/${applicationDetails.rssbCertificateDocumentFile?.type};base64,${applicationDetails.rssbCertificateDocumentFile?.fileText}`}style={{width: 150, height: 150}}/> */}
                      <p>
                        {applicationDetails.rssbCertificateDocumentFile?.name}
                      </p>
                      <span
                        style={{ marginBottom: "0px", cursor: "pointer" }}
                        onClick={() =>
                          handleFileDownload(
                            applicationDetails.rssbCertificateDocumentFile
                              ?.fileText,
                          )
                        }
                      >
                        download
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </ReviewCard>
          </div>
        </div>
      </DashBoardContainer>
    </div>
  );
};

export default FirmApplicationStatus;
